import { render, staticRenderFns } from "./LogoutListItem.vue?vue&type=template&id=10c5e6ef&"
import script from "./LogoutListItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LogoutListItem.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c5e6ef')) {
      api.createRecord('10c5e6ef', component.options)
    } else {
      api.reload('10c5e6ef', component.options)
    }
    module.hot.accept("./LogoutListItem.vue?vue&type=template&id=10c5e6ef&", function () {
      api.rerender('10c5e6ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/LogoutListItem.vue"
export default component.exports